import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { typography } from '@clds/typography';

export interface SideMenuHeaderRootProps {
  verticalPadding: 'xs' | 'none';
}

const SideMenuHeaderRoot = styled.div<SideMenuHeaderRootProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${typography.xs.lowContrast};

  padding: ${({ verticalPadding, theme }) => (verticalPadding === 'none' ? 0 : theme.spacing.xs)} ${(props) => props.theme.spacing.sm};
`;

const RightSlotWrapper = styled.div`
  padding-left: ${(props) => props.theme.spacing.sm};
`;

interface SideMenuHeaderProps {
  rightSlot?: ReactNode;
}

export const SideMenuHeader: FC<React.PropsWithChildren<SideMenuHeaderProps & Partial<SideMenuHeaderRootProps>>> = ({
  children,
  rightSlot,
  verticalPadding = 'xs',
}) => {
  return (
    <SideMenuHeaderRoot verticalPadding={verticalPadding}>
      {children}
      {rightSlot && <RightSlotWrapper>{rightSlot}</RightSlotWrapper>}
    </SideMenuHeaderRoot>
  );
};
